import { gql } from '@apollo/client'
import { getAuth } from 'CRM/helpers/auth'
import { apiClient } from 'shared/helpers/api'
import { mutate, query } from 'shared/helpers/graphql'

export async function getPackages() {
  return await query(gql`
    query Packages {
      packages {
        id
        display_name
        name
        package_type
        price
        room_classifications {
          id
          categories
        }
        unit_plans {
          id
        }
        vendor {
          id
          full_name
        }
      }
    }
  `)
}

export async function getPackage(id) {
  return await query({
    query: gql`
      query Packages($filters: all_packages_filters) {
        packages(filters: $filters) {
          id
          display_name
          name
          price
          unit_plans {
            id
            src
            display_name
            unit_type {
              number_of_bathrooms
              number_of_bedrooms
              size_to_display
              property {
                id
                property_name
                real_estate_company {
                  id
                  company_name
                }
              }
            }
          }
          vendor {
            id
            full_name
          }
          room_classifications {
            categories
            id
            package_assets {
              count
              category {
                id
                category_name
              }
            }
            room_classification {
              id
              weight
              classification_name
            }
          }
        }
      }
    `,
    variables: {
      filters: {
        packages: {
          ids: [id],
        },
      },
    },
  })
}

export async function createFromDesignLayout(payload) {
  return apiClient.post('/api/package', payload, {
    headers: {
      Authorization: getAuth() ? `Bearer ${getAuth()}` : process.env.REACT_APP_API_TOKEN,
    },
  })
}

export async function upsertPackage(payload) {
  return mutate(
    {
      packages: [payload],
    },
    gql`
      mutation Upsert_packages($packages: [packages_input]) {
        upsert_packages(packages: $packages) {
          id
        }
      }
    `,
  )
}
